import React from 'react';
import RootController from './RootController';
import RootSiblings from './RootSiblings';
export default function wrapRootComponent(Root, renderSibling) {
  const controller = new RootController();
  return {
    Root: props => {
      return /*#__PURE__*/React.createElement(RootSiblings, {
        controller: controller,
        renderSibling: renderSibling
      }, /*#__PURE__*/React.createElement(Root, props));
    },
    manager: {
      update(id, element, callback) {
        controller.update(id, element, callback);
      },
      destroy(id, callback) {
        controller.destroy(id, callback);
      }
    }
  };
}